import { FC } from 'react';

const Version: FC = () => {
  return (
    <div className="text-[#031F47]">
      Version 1.2.3
    </div>
  );
};

export { Version };
